
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ShSelectedFacetValue } from '../facet/entities/facet.entity';
import { IconSize } from '../icon/entities/icon-sizes.entity';
import { ShIconModule } from '../icon/icon.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    standalone: true,
    selector: 'sh-facet-summary',
    templateUrl: './facet-summary.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShIconModule, TranslateModule],
    styleUrls: ['./facet-summary.component.scss']
})
export class ShFacetSummaryComponent {
    public iconSize: IconSize = IconSize.SMALL;

    @Input() selectedFacets!: ShSelectedFacetValue[];
    @Input() clearMsg = 'Clear';
    @Input() chosenFiltersMsg = 'Chosen filters:';

    @Output() removeFacetValue: EventEmitter<ShSelectedFacetValue> = new EventEmitter();
    @Output() clear: EventEmitter<void> = new EventEmitter();

    onRemove(selectedFacetValue: ShSelectedFacetValue) {
        this.removeFacetValue.next(selectedFacetValue);
    }

    onClear() {
        this.clear.next();
    }
}
